import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setMediaState as setMediaStateAction } from 'redux/modules/device';
import { MEDIA_QUERY_MAP } from 'constants/media-queries';
import { debounce } from 'helpers/debounce';
import { insertEntry } from 'helpers/object';
var DEBOUNCE_MS = 100;
export var matchMedias = function matchMedias() {
  return Object.entries(MEDIA_QUERY_MAP).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        breakpoint = _ref2[0],
        query = _ref2[1];

    return [breakpoint, window.matchMedia(query).matches];
  }).reduce(insertEntry, {});
};
export var mapDispatchToProps = {
  setMediaState: setMediaStateAction
};
export var MediaListenerUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(MediaListenerUnwrapped, _Component);

  function MediaListenerUnwrapped() {
    _classCallCheck(this, MediaListenerUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(MediaListenerUnwrapped).apply(this, arguments));
  }

  _createClass(MediaListenerUnwrapped, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      if (__CLIENT__ && !MediaListenerUnwrapped.listener) {
        var listener = function listener() {
          return _this.props.setMediaState(matchMedias());
        }; // Call listener to set state from the window, then attach debounced listener


        listener();
        MediaListenerUnwrapped.listener = debounce(listener, DEBOUNCE_MS);
        window.addEventListener('resize', MediaListenerUnwrapped.listener);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (__CLIENT__) {
        window.removeEventListener('resize', MediaListenerUnwrapped.listener);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return MediaListenerUnwrapped;
}(Component);

_defineProperty(MediaListenerUnwrapped, "listener", null);

MediaListenerUnwrapped.propTypes = {
  setMediaState: PropTypes.func.isRequired
};
export var MediaListener = connect(null, mapDispatchToProps)(MediaListenerUnwrapped);